// import ElementPlus from 'element-plus';
// import { Utils } from '@sdesign/element-plus';
import '../styles/element-plus-variables.scss';
// 规范(默认)
import '@sdesign/theme/index.css';
import '@sdesign/theme/src/css/brand/_blue.css';
import '@sdesign/theme/src/css/brand/_red.css';
import '../styles/o_reset.scss';
import '../styles/theme_orange.css';
import '../styles/theme/blue_light.css';
import '../styles/theme/blue_brand.css';
import '../styles/theme/blue_black.css';
import '../styles/theme/red_light.css';
import '../styles/theme/red_black.css';
import '../styles/layout-size/loose.scss';
import '../styles/layout-size/compact.scss';

import type { PluginOptions } from './type';

const options: PluginOptions = {
  onVuePluginRegister: async ({ app }) => {
    // 命名空间、多语言（修改的话才加上）
    // app.use(ElementPlus, {
    //   namespace: 'sf-olayout',
    //   // locale: Utils.zhCn, // 默认按SFDesign定义的多语言进行适配
    // });
  },
};

export default options;
